import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonsLogicService } from './logic/persons/persons-logic.service';
import { PersonsService } from './logic/persons.service';
import { PersonsDaoService } from './dao/persons-dao.service';
import { PersonsDbDaoService } from './dao/persons-dao/persons-db-dao.service';
import { PersonsDbTableDefinition } from './dao/persons-dao/persons-db-table-definition';
import { LocalPersonsDbTableDefinition } from './dao/persons-dao/local-persons-db-table-definition';
import { LocalPersonOverridesDbTableDefinition } from './dao/persons-dao/local-person-overrides-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: PersonsService, useClass: PersonsLogicService },
    { provide: PersonsDaoService, useClass: PersonsDbDaoService },
    { provide: PersonsDbTableDefinition },
    { provide: LocalPersonsDbTableDefinition },
    { provide: LocalPersonOverridesDbTableDefinition },
  ]
})
export class PersonsModule {}
